import './App.css';
import {Container} from './components/container/container.tsx'

function App() {
  return (
    <Container />
  );
}

export default App;
